import { render, staticRenderFns } from "./VolunteerProjectsView.vue?vue&type=template&id=610e2d72&scoped=true&"
import script from "./VolunteerProjectsView.vue?vue&type=script&lang=js&"
export * from "./VolunteerProjectsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610e2d72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VCardTitle})
